<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Exibir Depoimentos</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row v-if="listCards.data">
          <b-col md="6" v-for="card in listCards.data" :key="card.id">
            <b-card>
              <blockquote class="blockquote mb-0">
                <p>
                  <i class="fa fa-quote-left mr-4"></i>{{ card.texto }}
                </p>
                <footer class="blockquote-footer">
                  {{ card.name }}<br>
                  <i class="fa fa-map-marker"></i><cite title="municipioAtuacao"> {{ card.cidade }}/{{card.sigla}}</cite>
                </footer>
              </blockquote>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="text-center" v-else><h4>Nenhum registro de depoimento...</h4></b-row>
      </b-card-body>
      <b-card-footer>
          <pagination
                v-show="listCards.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
              ></pagination>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import AuthTemplate from '@/templates/auth/AuthTemplate'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/PaginationAvaliacoes'

miniToastr.init()

export default {
  name: 'Depoimentos',
  components: {
    AuthTemplate,
    Pagination
  },
  created () {
    this.$store.dispatch('buscarMunicipiosProgramas')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      totalPorPagina: 6,
      resource: 'depoimentos-list',
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      }
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    'municipiosprogramas': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  mounted () {},
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    listCards () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/depoimentos/ListDepoimentos.vue